<!doctype html>
<html lang="pt-BR">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
    <meta name="theme-color" content="#0d2543" />
    <title>Visualizador Lumos Engenharia</title>
    <link rel="stylesheet" href="/src/style.css" />
  </head>
  <body>
    <header id="lumos-header">
      <img id="lumos-logo" src="/lumos-logo-white.png" alt="Lumos Engenharia" />
      <div id="lumos-projeto">
        <div class="num">—</div>
        <div class="nome">Carregando…</div>
      </div>
    </header>

    <aside id="lumos-sidebar" aria-label="Disciplinas e andares">
      <button id="lumos-sidebar-close" aria-label="Fechar menu">×</button>
      <section>
        <h3>Disciplinas</h3>
        <ul id="lumos-discs"></ul>
      </section>
      <section id="lumos-corte-sec">
        <h3>Corte</h3>
        <div id="lumos-corte">
          <div class="corte-eixos">
            <button data-eixo="y" title="Plano horizontal — corta por altura">Horizontal</button>
            <button data-eixo="x" title="Plano vertical no eixo X">Vertical X</button>
            <button data-eixo="z" title="Plano vertical no eixo Z">Vertical Z</button>
          </div>
          <div class="corte-ctrl" data-for="y" hidden>
            <div class="corte-cab">
              <span class="rot">Horizontal</span>
              <span class="val">—</span>
              <button class="flip" title="Inverter o lado que fica">⇅</button>
            </div>
            <input type="range" min="0" max="1000" value="500" aria-label="Posição do corte horizontal" />
          </div>
          <div class="corte-ctrl" data-for="x" hidden>
            <div class="corte-cab">
              <span class="rot">Vertical X</span>
              <span class="val">—</span>
              <button class="flip" title="Inverter o lado que fica">⇄</button>
            </div>
            <input type="range" min="0" max="1000" value="500" aria-label="Posição do corte em X" />
          </div>
          <div class="corte-ctrl" data-for="z" hidden>
            <div class="corte-cab">
              <span class="rot">Vertical Z</span>
              <span class="val">—</span>
              <button class="flip" title="Inverter o lado que fica">⇄</button>
            </div>
            <input type="range" min="0" max="1000" value="500" aria-label="Posição do corte em Z" />
          </div>
          <label class="corte-opt"><input type="checkbox" id="corte-por-pav" /> cortar no pavimento clicado</label>
          <label class="corte-opt"><input type="checkbox" id="corte-mostrar-plano" /> mostrar o plano do corte</label>
          <button id="corte-limpar" hidden>Limpar cortes</button>
        </div>
      </section>
      <section>
        <h3>Pavimentos</h3>
        <ul id="lumos-floors"></ul>
      </section>
      <section id="lumos-elem-info" hidden>
        <h3>Elemento</h3>
        <dl id="lumos-elem-fields"></dl>
      </section>
    </aside>

    <main id="lumos-canvas-wrap">
      <div id="lumos-canvas"></div>
      <div id="lumos-loader" hidden><div class="bar"><div></div></div><span></span></div>
      <button id="lumos-menu-toggle" aria-label="Abrir menu">☰</button>

      <div id="lumos-tools">
        <button data-tool="fit" title="Enquadrar">⛶</button>
        <button data-tool="shot" title="Screenshot">📷</button>
      </div>
    </main>

    <footer id="lumos-footer">
      <span>Visualizador Lumos Engenharia</span>
      <span id="lumos-expira"></span>
    </footer>

    <div id="lumos-error" hidden>
      <h2>Não foi possível carregar este projeto</h2>
      <p id="lumos-error-msg"></p>
      <p>Se o link foi enviado pela Lumos Engenharia há mais de um ano, é possível que ele tenha expirado. Solicite um novo.</p>
    </div>

    <script type="module" src="/src/main.ts"></script>
  </body>
</html>
